import { PublicClientApplication } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const MSAL_DEAFULT_CONFIG = {
  auth: {
    clientId: "6deeaf3f-449a-4d16-ac59-d02bbc7e4386",
    authority:
      "https://login.microsoftonline.com/a6112416-07b0-41a5-9bb1-d146b575c975",
    redirectUri: import.meta.env.VITE_REDIRECT_URI,
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "localStorage",
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
  },
};

// AD group IDs for access control
export const CHOP_GENAI_DEVELOPERS_GROUP = "f26c1726-ebef-4ccb-9109-6c3d72a74e15";
export const CHOP_AI_ASSISTANT_USERS_PROD_GROUP = "4b985c8e-6f72-48e8-8b67-085157082409";
export const CHOP_AI_ASSISTANT_USERS_GROUP = "00a8fcda-e3f3-42f5-90f5-3913ba238031";
export const POLICY_ASSISTANT_USERS_GROUP = "5fbe9d31-b2d4-47f1-b2b3-35d492506b89";

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const LOGIN_SCOPES = [MSAL_DEAFULT_CONFIG.auth.clientId + "/.default"];

// Creating msal app globally
export const msalApp = new PublicClientApplication(MSAL_DEAFULT_CONFIG);
